/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('ul.acf-radio-list[data-other_choice="1"] li:last-of-type label').each(function () {
		jQuery(this).append('Other');
	});

	jQuery('.acf-required').each(function () {
		jQuery(this).text('(required)');
	});

	var teen = 0;
	jQuery('td.acf-field[data-name="teen_rules"] input').each(function() {
		jQuery('td.acf-field[data-name="teen_rules"] input').attr('title', 'Teen Rule ' + teen++);
	});

	var parent = 0;
	jQuery('td.acf-field[data-name="parent_rules"] input').each(function() {
		jQuery('td.acf-field[data-name="parent_rules"] input').attr('title', 'Parent Rule ' + parent++);
	});

	var consequence = 0;
	jQuery('td.acf-field[data-name="consequence"] input').each(function() {
		jQuery('td.acf-field[data-name="consequence"] input').attr('title', 'Parent Rule ' + consequence++);
	});

	if( document.body.className.match('page-id-56') ) {
		document.querySelector(".acf-field-5cae48b004a8b input.hasDatepicker").setAttribute("title","review date");
	 }

}); 

jQuery(document).on('open.zf.reveal', '[data-reveal]', function () {
	var modal = jQuery(this);
	modal.find("#modalTitle").focus();
});

if( document.body.className.match('page-id-1177') ) {
	document.getElementById("input_1_1").removeAttribute("aria-describedby");
 }


document.getElementsByClassName("acf-js-tooltip").tabIndex = 1;

function replaceRadios(){
	var radios = document.querySelectorAll('.acf-field-radio:not(.radio-legend)');
  
	radios.forEach(function(radio){
	  let fieldset = document.createElement('fieldset');
	  let legend = document.createElement('legend');
	
	  var legendText = radio.querySelector('.acf-label label').innerText;
	  var legendDesc = radio.querySelector('.acf-label .description');
	
	  legend.innerHTML = legendText;
	
	  var hiddenInput = radio.querySelector('.acf-input > input[type="hidden"]');
	  var inputList = radio.querySelectorAll('.acf-input ul li');
	
	  fieldset.append(legend);
	  fieldset.append(legendDesc);
	  fieldset.append(hiddenInput);
	
	  inputList.forEach(function(input){
		fieldset.append(...input.childNodes);
	  });
	
	  radio.append(fieldset);
	
	  radio.querySelector('.acf-label').remove();
	  radio.querySelector('.acf-input').remove();
	  radio.classList.add('radio-legend');
	});
  }
  
  function replaceACFLabels(){
	var headLabels = document.querySelectorAll('#acf-form > .acf-fields > .acf-field > .acf-label > label');
  
	headLabels.forEach(function(label){
	  let heading = document.createElement('h2');
	  heading.classList.add('rule-heading');
	
	  heading.innerHTML = label.innerText;
	
	  label.parentNode.append(heading);
	  label.remove();
	});
  }
  
  window.addEventListener('load', function () {
   if (this.document.body.classList.contains('page-template-templatespage-edit-checkpoints-php') || this.document.body.classList.contains('page-template-templatespage-new-checkpoint-php') ){
	replaceRadios();
  
	document.addEventListener('click', function (event) {
	  if (event.target.matches('a.acf-icon.-plus')){
		setTimeout(function(){
		  replaceRadios();
		}, 2000);
	  }
	}, false);  
   }
  
   if (this.document.body.classList.contains('page-id-82')){
	replaceACFLabels()
   }
  
  }, false);

